import ErrorPageImage from '@assets/images/PermissionDenied.png'
import MediaImage from '@components/MediaImage'
import AppPaths from '@globals/paths'
import { colors } from '@globals/themes/defaultTheme'
import usePreviousPath from '@globals/usePreviousPath'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { T } from '@transifex/react'
import { ButtonStyles } from './RoutingStyles'

const NoMobileAccessPage: React.FC = () => {
  const { navigateToPrevious } = usePreviousPath()
  return (
    <Stack
      useFlexGap
      spacing={3}
      sx={{
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <MediaImage
        imgSrc={ErrorPageImage}
        maxWidth={320}
        maxHeight={320}
        backgroundColor="transparent"
      />
      <Stack
        sx={{
          maxWidth: 600,
          alignItems: 'center',
          p: 2,
          mt: -4,
        }}>
        <Stack
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
            mb: 1,
          }}>
          <Typography
            variant="h2"
            sx={{
              mt: { xs: 0 },
            }}>
            <T _str="This feature isn’t available on mobile" />
          </Typography>
          <Typography sx={{ color: colors.grayMedium, textAlign: 'center' }}>
            <T _str="Use desktop for full access" />
          </Typography>
        </Stack>
        <Button
          id="btnGenericErrorRefresh"
          variant="text"
          onClick={() => navigateToPrevious(AppPaths.tenant.home())}
          sx={ButtonStyles}>
          <T _str="Go back" />
        </Button>
      </Stack>
    </Stack>
  )
}

export default NoMobileAccessPage
